import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ViewManagerContext } from 'contexts/ViewManagerContext';
import { registerTableController } from 'utils/benchmark';
import { isRecording, recordNav } from 'utils/handRecorder';

/**
 * Bridges the ViewManager's table controls to the benchmark module.
 *
 * PerfHud (which hosts the benchmark UI) is mounted OUTSIDE ViewManagerProvider,
 * so it can't call openTable/returnToLobby directly. This tiny component is
 * mounted INSIDE the provider and registers those controls with the benchmark
 * module while it's alive — that's what lets the multi-table observe benchmark
 * replay the exact "click a lobby table to observe it" action a human uses.
 *
 * Renders nothing.
 */
const BenchmarkTableBridge = () => {
  const { openTable, openGrid, returnToLobby } = useContext(ViewManagerContext);
  useEffect(() => {
    registerTableController({ openTable, openGrid, returnToLobby });
    return () => registerTableController(null);
  }, [openTable, openGrid, returnToLobby]);

  // Record view/mode switches (route changes) while a recording is active, so
  // replay can reproduce the switching and capture its cost. No-op unless
  // recording (and never during replay, which doesn't set the recording flag).
  const location = useLocation();
  useEffect(() => {
    if (isRecording()) recordNav(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default BenchmarkTableBridge;
